module.exports = __webpack_public_path__ + "static/assets/38ac2210b486d930f72c951ad081e4c0.svg";